import { render, staticRenderFns } from "./RelatedResource.vue?vue&type=template&id=1d5b2b95&scoped=true"
import script from "./RelatedResource.vue?vue&type=script&lang=js"
export * from "./RelatedResource.vue?vue&type=script&lang=js"
import style0 from "./RelatedResource.vue?vue&type=style&index=0&id=1d5b2b95&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d5b2b95",
  null
  
)

export default component.exports